interface EventManager {
    /**
     * Register an event handler
     */
    on(event: string, callback: (...args: unknown[]) => void): EventManager;

    /**
     * Remove an event handler
     */
    off(event: string, callback: (...args: unknown[]) => void): EventManager;

    /**
     * Emit an event
     */
    emit(event: string, ...args: any[]): void;
}

export const eventManager: EventManager = {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    list: new Map(),
    on(event, callback) {
        this.list.has(event) || this.list.set(event, []);
        this.list.get(event).push(callback);
        return this;
    },
    off(event, callback) {
        this.list.has(event) && this.list.set(event, this.list.get(event).filter(c => c !== callback));
        return this;
    },
    emit(event, ...args) {
        this.list.has(event) &&
            this.list.get(event).forEach(cb =>
                setTimeout(() => cb(...args), 0)
            );
    },
};
